module.exports = __webpack_public_path__ + "img/chevron-down.3aa76e41.svg";